import React from 'react';
import styled, { css } from 'styled-components';
import shortid from 'shortid';

import style from 'css';

export default ({ label, onChange, white, ...rest}) => {
    const id = shortid.generate();
    return (
        <Wrapper white={white}>
            <input id={id} type="radio" onChange={e => onChange(e)} {...rest} />
            <label htmlFor={id}>{label}</label>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: relative;
    input {
        position:absolute;
        z-index:-1;
        opacity: 0;
    }
    label {
        display: inline-flex;
        align-items: center;
        font-size: 20px;
        cursor: pointer;
        &:before {
            content: '';
            width: 24px;
            height: 24px;
            border-radius: 24px;
            display: inline-block;
            border: 2px solid ${style.colors.blue};
            cursor: pointer;
            margin-right: 16px;
        }
        &:hover:before {
            border: 2px solid ${style.colors.black};
        }
        &:active:before {
            border: 2px solid ${style.colors.black};
            background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5SZWN0YW5nbGUgMyBDb3B5IDEyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkRlc2lnbi1pbnZlbnRvcnkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGb3JtLWVsZW1lbnRzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE5LjAwMDAwMCwgLTM5OS4wMDAwMDApIiBmaWxsPSIjMzMzMzMzIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0zLUNvcHktMTIiIHg9IjUxOSIgeT0iMzk5IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSI4Ij48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') center center no-repeat;
        }
    }
    input:checked + label:before {
        border: 2px solid ${style.colors.blue};
        background: #fff url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5SZWN0YW5nbGUgMyBDb3B5IDEyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkRlc2lnbi1pbnZlbnRvcnkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGb3JtLWVsZW1lbnRzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE5LjAwMDAwMCwgLTM5OS4wMDAwMDApIiBmaWxsPSIjMDA2Q0VGIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0zLUNvcHktMTIiIHg9IjUxOSIgeT0iMzk5IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSI4Ij48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') center center no-repeat;
    }

    ${props => props.white && css`
        label {
            color: white; 
            &:before {
                border: 2px solid white;
                width: 20px;
                height: 20px;
                border-radius: 20px;
            }
            &:hover:before {
                border: 2px solid white;
            }
            &:active:before {
                width: 14px;
                height: 14px;
                border-radius: 14px;
                border: 4px solid #002957;
                box-shadow: 0 0 0 2px ${style.colors.white};
                background: white; 
            }
        }
        input:checked + label:before {
            width: 14px;
            height: 14px;
            border-radius: 14px;
            border: 4px solid #002957;
            box-shadow: 0 0 0 2px ${style.colors.white};
            background: white; 
        }

        @media(max-width: 767px) {
            label {
                font-size: 16px;
                
                &:before {
                    width: 14px;
                    height: 14px;
                    border-radius: 14px;
                    margin-right: 6px; 
                }
                &:active:before {
                    width: 8px;
                    height: 8px;
                    border-radius: 8px;
                }
            }
            input:checked + label:before {
                width: 8px;
                height: 8px;
                border-radius: 8px;
            }
        }
    `}
`



// WEBPACK FOOTER //
// ./src/partials/formElements/Radio.js